
import { reactive, toRefs } from 'vue';
export default function (form) {
  const state = reactive({
    btn_loading: false, //弹窗内按钮loading
  });
  
  const init_form = (record) => {
    console.log('record',record)
    if (!record) return;
    for (var key in form) {
      form[key] = record[key];
    }
    if (record.id) {
      form.id = record.id;
    }
  };
  
  return {
    ...toRefs(state),
    init_form,
  };
}

export const dialogProps = {
  record: {
    type: [Object, Array],
  },
  config: {
    type: Object,
  },
  close: {
    type: Function,
    required: true,
  },
  ok: {
    type: Function,
    required: true,
  },
};
